<div
  [ngClass]="{ 'new-messages': chat.notificacionAgente > 0 }"
  class="chat-item-container">
  <!-- CONTENIDO PRINCIPAL -->
  <div class="chat-item-content" (click)="newChatView(true)">
    <p *ngIf="chat.notificacionAgente > 0" class="texto-secundario">{{ chat.notificacionAgente }} pendientes de lectura</p>
    <!-- CHAT DE NEGOCIO -->
    <ng-container *ngIf="chat.usuario.role !== 'Anonimo'">
      <p *ngIf="chat.negocio?.id">
        <span>{{ chat.negocio.id }}</span>
        <abbr [title]="chat.negocio.nombre"> - {{ chat.negocio.nombre }}</abbr>
      </p>

      <p *ngIf="chat?.sucursal?.id">
        <span>Sucursal:</span>
        <abbr [title]="chat.sucursal.id">
          <b class="texto-warn">{{ chat.sucursal.id }}</b> - {{ chat.sucursal.nombre }}
        </abbr>
      </p>

      <p *ngIf="chat.negocio?.giro">
        <abbr [title]="'giro'"> <b>Giro:</b> {{ chat.negocio.giro }} </abbr>
      </p>

      <p>
        <abbr [title]="chat.usuario.nombre">
          <b>{{ chat.usuario.role }}:</b> {{ chat.usuario.nombre }}
        </abbr>
      </p>
    </ng-container>

    <!-- CHAT ANÓNIMO -->
    <ng-container *ngIf="chat.usuario.role === 'Anonimo'">
      <p>
        <span>Nombre:</span>
        <abbr [title]="chat.usuario.nombre">
          <b>{{ chat.usuario.nombre }}</b>
        </abbr>
      </p>

      <p class="acortarText">
        <abbr title="Teléfono"> <b>Teléfono:</b> {{ chat.usuario.telefono }} </abbr>
      </p>
    </ng-container>

    <!-- AGENTE -->
    <p>
      <b *ngIf="chat.agente">Agente:</b>
      {{ chat.agente ? chat.agente.id + ' ' + chat.agente.nombre : '' }}
    </p>

    <!-- ESTADO DEL CHAT -->
    <p *ngIf="chat.usuario">
      <abbr [title]="chat.usuario.role"> <b>Rol:</b> {{ chat.usuario.role }} </abbr>
      <span class="label-linnegocios ml-3" [ngClass]="{ 'bg-secundario': !chat.agente, 'bg-primario': chat.agente }">
                   {{ chat.agente ? 'EN SEGUIMIENTO' : 'NUEVO' }}
                </span>
    </p>
  </div>

  <!-- ACCIONES -->
  <div class="chat-item-actions">
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Opciones">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="newChatView(false)" *ngIf="agente== 'other'">
        <mat-icon>visibility</mat-icon>
        <span>Solo ver</span>
      </button>

      <button mat-menu-item (click)="closeChat()" *ngIf="agente== 'own'">
        <mat-icon>indeterminate_check_box</mat-icon>
        <span>Finalizar chat</span>
      </button>
    </mat-menu>
  </div>
</div>
<mat-divider></mat-divider>


